import gql from "graphql-tag";

const GET_9142A_FORM_DATA_V2 = gql`
  query getForm9142AByIdV2($id: String!) {
    getForm9142AByIdV2(id: $id) {
      payload {
        formVersionId
        a1_employer_type
        a1_employer_type_a
        a1a_sole_employer
        a1a_joint_employer
        a1a_agent
        a2_is_contractor
        a3_nature_of_need
        a4_is_temp_need_complete
        a5_is_emergency
        a6_is_emergency_justification_complete
        b1_emp_legal_name
        b2_emp_dba
        b3_emp_address_1
        b4_emp_address_2
        b5_emp_city
        b6_emp_state_id
        b7_emp_zip
        b8_emp_country_id
        b9_emp_province
        b10_emp_phone
        b11_emp_phone_ext
        b12_emp_fein
        b13_emp_naics
        b13_emp_naics_description
        c1_poc_last
        c2_poc_first
        c3_poc_middle
        c4_poc_title
        c5_poc_address_1
        c6_poc_address_2
        c7_poc_city
        c8_poc_state_id
        c9_poc_zip
        c10_poc_country_id
        c11_poc_province
        c12_poc_phone
        c13_poc_phone_ext
        c14_poc_email
        d1_representation_type
        d2_agent_last
        d3_agent_first
        d4_agent_middle
        d5_agent_address_1
        d6_agent_address_2
        d7_agent_city
        d8_agent_state_id
        d9_agent_zip
        d10_agent_country_id
        d11_agent_province
        d12_agent_phone
        d12_agent_phone_ext
        d14_agent_email
        d15_agent_firm_name
        d16_agent_firm_fein
        d17_agent_bar_number
        d18_agent_court_state_id
        d19_agent_court_name
        d20_is_agent_agreement_complete
        d21_is_agent_mspa_complete_file
        d21_is_agent_mspa_complete
        e1_soc_code
        e2_soc_title
        e3_is_job_order_complete
        e4_is_joint_employer_complete
        e5_is_work_locations_complete
        e6_is_work_contracts_complete
        e7_is_mspa_complete
        e7_is_mspa_complete_file
        e8_is_surety_bond_complete
        e9_is_housing_transportation
        f1_is_appendix_a_complete
        f2_is_joint_appendix_a_complete
        g1_preparer_last
        g2_preparer_first
        g3_preparer_middle
        g4_preparer_fein
        g5_preparer_firm_name
        g6_preparer_email
        files {
          machine_name
          application_id
          FileType
          fileType
          document_name
          size
          displayName
          lastModified
          state
          percentage
          document_path
        }
      }
      form_ui {
        pages_visited
        pages_errors
      }
    }
  }
`;

const SUBMIT_9142A_FORM_V2 = gql`
  mutation SubmitForm9142AV2(
    $id: String!
    $Form9142AFormDataV2: Form9142AFormDataV2!
    $token: String
  ) {
    SubmitForm9142AV2(
      Form9142AFormDataV2: $Form9142AFormDataV2
      id: $id
      token: $token
    )
  }
`;

const UPDATE_9142A_FORM_V2 = gql`
  mutation updateForm9142AByIdV2(
    $id: String!
    $Form9142AFormDataV2: Form9142AFormDataV2!
    $formUI9142A: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm9142AByIdV2(
      id: $id
      Form9142AFormDataV2: $Form9142AFormDataV2
      formUI9142A: $formUI9142A
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const UPDATE_FORM_790_LOOKUP = gql`
  mutation updateForm790LookupTable(
    $Form790LookupUpdateInput: Form790LookupUpdateInput!
  ) {
    updateForm790LookupTable(
      Form790LookupUpdateInput: $Form790LookupUpdateInput
    )
  }
`;

const UPDATE_JO_LINKINGV2 = gql`
  mutation updateJOLinkingV2(
    $Form790LookupUpdateInput: Form790LookupUpdateInput!
    $id: String!
    $Form9142AFormDataV2: Form9142AFormDataV2!
    $formUI9142A: formUIInput
  ) {
    updateJOLinkingV2(
      Form790LookupUpdateInput: $Form790LookupUpdateInput
      id: $id
      Form9142AFormDataV2: $Form9142AFormDataV2
      formUI9142A: $formUI9142A
    )
  }
`;

const GET_9142A_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
    }
  }
`;

export {
  GET_9142A_FORM_DATA_V2,
  UPDATE_9142A_FORM_V2,
  SUBMIT_9142A_FORM_V2,
  UPDATE_FORM_790_LOOKUP,
  GET_9142A_PROFILES,
  UPDATE_JO_LINKINGV2,
};
